import { Languages, Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';
import { SupportedLanguage } from '../../services/recipes/recipesService';

interface LanguageTabBarProps {
  activeLanguage: SupportedLanguage;
  onChangeLanguage: (lang: SupportedLanguage) => void;
  onTranslate: () => void;
  isTranslating: boolean;
  hasContent: { en: boolean; es: boolean; nl: boolean };
}

const LANGUAGES: { code: SupportedLanguage; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
  { code: 'nl', label: 'NL' },
];

export default function LanguageTabBar({
  activeLanguage,
  onChangeLanguage,
  onTranslate,
  isTranslating,
  hasContent,
}: LanguageTabBarProps) {
  return (
    <div className="flex items-center gap-2 mb-4">
      {LANGUAGES.map((lang) => {
        const isActive = activeLanguage === lang.code;
        const filled = hasContent[lang.code];
        return (
          <button
            key={lang.code}
            onClick={() => onChangeLanguage(lang.code)}
            className={cn(
              'px-3 py-1.5 rounded-lg text-xs font-semibold transition-all',
              isActive
                ? 'ring-2 ring-offset-1 ring-zinc-900 dark:ring-zinc-100'
                : '',
              filled
                ? 'bg-[#ECFDF3] text-[#027A48] dark:bg-green-900/20 dark:text-green-400'
                : 'bg-[#F2F4F7] text-[#98A2B3] dark:bg-zinc-800 dark:text-zinc-500'
            )}
          >
            {lang.label}
          </button>
        );
      })}
      <button
        onClick={onTranslate}
        disabled={isTranslating || !hasContent[activeLanguage]}
        className={cn(
          'ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition',
          'bg-blue-600 dark:bg-blue-500 text-white dark:text-white hover:bg-blue-700 dark:hover:bg-blue-600',
          'disabled:opacity-40 disabled:cursor-not-allowed'
        )}
      >
        {isTranslating ? (
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
        ) : (
          <Languages className="w-3.5 h-3.5" />
        )}
        {isTranslating ? 'Translating...' : 'Translate'}
      </button>
    </div>
  );
}
